"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationFieldView = exports.CSS = void 0;
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var location_input_1 = require("../../../components/input/location.input");
var location_input_state_1 = require("../../../components/input/location.input.state");
var theme_1 = require("../../../components/theme");
var i18n_1 = require("../../../i18n");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var field_info_1 = require("../../field.info/field.info");
exports.CSS = {
    container: 'c-Location',
    table: 'c-Location__table',
    row: 'c-LocationField',
    label: 'c-LocationField__label',
    value: 'c-LocationField__value',
    textfield: 'c-LocationField__text'
};
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.container] = {
        display: 'block',
        'align-items': 'center'
    },
    _a[exports.CSS.table] = {
        width: '100%',
        'border-collapse': 'separate'
    },
    _a[exports.CSS.row] = {
        display: 'block',
        'align-items': 'center',
        width: '100%'
    },
    _a[exports.CSS.label] = {
        display: 'inline-block',
        width: '20%'
    },
    _a[exports.CSS.value] = {
        display: 'inline-block',
        width: '70%'
    },
    _a[exports.CSS.textfield] = {
        display: 'inline-block',
        width: '300px'
    },
    _a));
var GPS_FIX_T_KEYS = {
    gps: i18n_1.T.FIELD_LOCATION_FIX_GPS,
    dgps: i18n_1.T.FIELD_LOCATION_FIX_DGPS,
    pps: i18n_1.T.FIELD_LOCATION_FIX_PPS,
    rtkfloat: i18n_1.T.FIELD_LOCATION_FIX_RTKFLOAT,
    rtkfixed: i18n_1.T.FIELD_LOCATION_FIX_RTKFIXED
};
var CollectionFieldViewLocation = /** @class */ (function () {
    function CollectionFieldViewLocation() {
    }
    CollectionFieldViewLocation.prototype.viewInline = function (field) {
        if (field.hasValue()) {
            var lines = [];
            lines.push(this.locationFieldLine(field.value.latitude, i18n_1.T.LAT, 7));
            lines.push(this.locationFieldLine(field.value.longitude, i18n_1.T.LNG, 7));
            if (field.value.altitude !== null) {
                lines.push(this.altitudeFieldLine(field.value.altitude, i18n_1.T.FIELD_LOCATION_ALT, 2));
            }
            return (0, mithril_1.m)('div', { className: exports.CSS.container }, (0, mithril_1.m)('table', { className: exports.CSS.table }, lines));
        }
        return null;
    };
    CollectionFieldViewLocation.prototype.locationFieldLine = function (value, label, precision) {
        return (0, mithril_1.m)('tr', { className: exports.CSS.row }, [
            (0, mithril_1.m)('td', { className: exports.CSS.label }, (0, i18n_1.Translate)(label)),
            (0, mithril_1.m)('td', { className: exports.CSS.value }, [(0, mithril_1.m)('div', { className: exports.CSS.textfield }, core_shared_1.IkeUnit.toFixed(value, precision))])
        ]);
    };
    CollectionFieldViewLocation.prototype.altitudeFieldLine = function (value, label, precision) {
        return (0, mithril_1.m)('tr', { className: exports.CSS.row }, [
            (0, mithril_1.m)('td', { className: exports.CSS.label }, (0, i18n_1.Translate)(label)),
            (0, mithril_1.m)('td', { className: exports.CSS.value }, [(0, mithril_1.m)('div', { className: exports.CSS.textfield }, core_shared_1.IkeUnit.display(value, services_1.Services.UserSettings.units))])
        ]);
    };
    CollectionFieldViewLocation.prototype.hasDetail = function (field) {
        return true;
    };
    CollectionFieldViewLocation.prototype.viewDetail = function (field) {
        if (!this.hasDetail(field)) {
            return null;
        }
        var raw = field.raw;
        var children = this.viewBasicDetail(field);
        if (raw.fix != null) {
            var translationKey = (0, i18n_1.Translate)(GPS_FIX_T_KEYS[raw.fix] || "\"".concat(raw.fix, "\""));
            children.push(field_info_1.FieldInfo.viewStat(i18n_1.T.FIELD_LOCATION_FIX, translationKey));
        }
        // Only show accuracy for non manual locations, if they have the token
        if ((services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_LOCATION_ACCURACY) || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE))
            && !field.isManual()
            && !field.isEdited()) {
            children.push(field_info_1.FieldInfo.viewStat(i18n_1.T.FIELD_LOCATION_ACCURACY, field.value.accuracy));
        }
        return mithril_1.m.fragment({}, children);
    };
    CollectionFieldViewLocation.prototype.viewBasicDetail = function (field) {
        var raw = field.raw;
        var res = [];
        //We want to display the provider first
        res.push(this.viewProvider(field));
        // Location has a ground altitude so show more information
        if ((field.isGPS() || field.isTrueSize()) && raw.groundAltitude != null) {
            res.push(field_info_1.FieldInfo.viewStat(i18n_1.T.FIELD_LOCATION_ALT_IKE, raw.deviceAltitude));
            res.push(field_info_1.FieldInfo.viewStat(i18n_1.T.FIELD_LOCATION_ALT_GROUND, raw.groundAltitude));
            res.push(field_info_1.FieldInfo.viewStat(i18n_1.T.FIELD_LOCATION_ANTENNA_HEIGHT, raw.antennaHeight));
        }
        return res;
    };
    CollectionFieldViewLocation.prototype.viewProvider = function (field) {
        if (field.isManual()) {
            return field_info_1.FieldInfo.viewStat(i18n_1.T.FIELD_PROVIDER, (0, i18n_1.Translate)(i18n_1.T.FIELD_LOCATION_MANUAL));
        }
        if (field.isEdited()) {
            return field_info_1.FieldInfo.viewStat(i18n_1.T.FIELD_PROVIDER, (0, i18n_1.Translate)(i18n_1.T.FIELD_LOCATION_EDITED));
        }
        if (field.isTrueSize()) {
            return field_info_1.FieldInfo.viewStat(i18n_1.T.FIELD_PROVIDER, (0, i18n_1.Translate)(i18n_1.T.FIELD_LOCATION_TRUESIZE));
        }
        if (field.isGPS()) {
            return field_info_1.FieldInfo.viewStat(i18n_1.T.FIELD_PROVIDER, (0, i18n_1.Translate)(i18n_1.T.FIELD_LOCATION_GPS));
        }
        return field_info_1.FieldInfo.viewStat(i18n_1.T.FIELD_PROVIDER, field.provider);
    };
    CollectionFieldViewLocation.prototype.viewEdit = function (field, ctrl) {
        if (this.canUpdate()) {
            var inputState_1 = ctrl.changeState.getState(field.id);
            if (inputState_1 == null) {
                inputState_1 = new location_input_state_1.LocationInputState(field.schema.displayName);
                inputState_1.onValue(function () {
                    if (!location_input_state_1.LocationInputState.equal(field.value, inputState_1.value)) {
                        field.Mutator.edited(inputState_1.value);
                    }
                });
                inputState_1.setValue(field.value);
                ctrl.changeState.addState(field.id, inputState_1);
            }
            return mithril_1.m.fragment({}, [location_input_1.LocationInput.view(inputState_1)]);
        }
        else {
            return this.viewInline(field);
        }
    };
    CollectionFieldViewLocation.prototype.hasClear = function (field) {
        return false;
    };
    CollectionFieldViewLocation.prototype.canUpdate = function () {
        if (!services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)) {
            return false;
        }
        return true;
    };
    return CollectionFieldViewLocation;
}());
exports.LocationFieldView = new CollectionFieldViewLocation();
//# sourceMappingURL=location.field.view.js.map